import Raven from "raven-js";
import axios from 'axios';

const baseURLapi = (process.env.REACT_APP_BASEURL_API?process.env.REACT_APP_BASEURL_API:'')

const store = (state,part,baseURL = baseURLapi) => {

  const data = {
    registration: {
      personal_information: state.personal_information,
      wallet: state.wallet,
      confirmation: state.confirmation
    },
    refererby: state.refererby,
    deviceprint: state.deviceprint,
    order: (state.order.investment.sum>0?state.order.investment:null),
  };

  const document_info = {
    document_type: state.document.document_type,
    document_id: state.document.document_id,
  }

  const data_doc = {
    ...data,
    document: {
      ...document_info,
      [part]: state.document.document_images[part],
    }
  }


  const request = {
    url: '/p/apply',
    method: 'post',
    baseURL,
    crossdomain: true,
    headers: {
      //'X-Captcha': state.confirmation.captcha,
      },

    data: data_doc,
  }

  process.env.REACT_APP_ENVIROMENT !== "prod" && console.log(request)

  try {
     
    return axios(request)

  } catch (error) {
    window.console && console.error(error);
    Raven.captureException(error);
  }
};
export default store;
